import { useMemo, useState } from "react";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AttendanceLocal } from "../../../../../../../../../../../../../../../@types/attendance-local";
import { useAttendanceLocalServiceList } from "../../../../../../../../../../../../../../../services/api-tansquery/attendance-local/service/list";
import { useDebouncedValue } from "../../../../../../../../../../../../../../../hooks/useDebounce";
import { AttendanceLocalService } from "../../../../../../../../../../../../../../../@types/attendance-local-service";
import { AttendanceLocalDepartmentGuiche } from "../../../../../../../../../../../../../../../@types/attendance-local-department-guiche";
import { AttendanceLocalDepartment } from "../../../../../../../../../../../../../../../@types/attendance-local-department";

type Props = {
    unidade_slug: AttendanceLocal["slug_unidade"];
    setor_unidade: AttendanceLocalDepartment["id"];
    guiche_id: AttendanceLocalDepartmentGuiche["id"];
    field: ControllerRenderProps<{
        guiche?: string;
        servico?: string;
    }, "servico">
    fieldState: ControllerFieldState
    style?: React.CSSProperties;
}

export default function ServiceField({ unidade_slug, setor_unidade, guiche_id, field, fieldState, style }: Props) {
    const [search, setSearch] = useState<string>();
    const debouncedSearch = useDebouncedValue(search, 500);
    const { data: serviceList, isLoading } = useAttendanceLocalServiceList({
        unidade_slug, setor_unidade, guiche_id,
        page: 1, search: debouncedSearch,
    });

    const options = useMemo(() => {
        return serviceList?.results || [];
    }, [serviceList]);

    const selected = useMemo(() => {
        return serviceList?.results.find(
            (service) => service.id === Number(field.value)
        ) || null;
    }, [serviceList, field.value]);

    function handleInputChange(_, value: string, reason: string) {
        if (reason === "input") {
            setSearch(value.trim() === "" ? undefined : value);
        }
    }

    function handleChange(_, newValue: AttendanceLocalService | null) {
        if (!newValue) {
            field.onChange("");
        } else {
            field.onChange(newValue.id.toString());
        }
    }

    return (
        <Autocomplete
            style={style}
            freeSolo={false}
            options={options}
            value={selected}
            onChange={handleChange}
            onInputChange={handleInputChange}
            getOptionLabel={(option) => option.servico.titulo}
            getOptionSelected={(option, value) => option.id === value.id}
            loading={isLoading}
            loadingText="Carregando serviços..."
            noOptionsText="Nenhum serviço encontrado"
            renderInput={(params) => (
                <TextField
                    {...params}
                    required
                    label="Serviço"
                    variant="outlined"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message || "Selecione um serviço"}
                    InputProps={{
                        ...params.InputProps,
                        required: false,
                        endAdornment: (
                            <>
                                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
